export const priceProcessing = (price) => {
  if (!price && price !== 0) return undefined;

  return (price % 1 === 0) ? price : (Math.ceil(price * 100) / 100).toFixed(2);
};
